import { combineReducers } from "redux";
import quickActionReducer from "./quickActionReducer";
import analyticsReducer from "./analyticsReducer";

const dashboardReducers = combineReducers({
  quickAction: quickActionReducer,
  analytics: analyticsReducer,
});

export default dashboardReducers;